import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useLanguage, getCustomsAgentManagementTranslation } from '../../hooks/useLanguage';

export const AgentsTable = ({ agents, isLoading, handleEdit, openDeleteModal }) => {
    const [isSpanish] = useLanguage();
    const [openDropdownId, setOpenDropdownId] = useState(null);
    return (
        <table className="min-w-full border-collapse border border-gray-300 mt-4 text-sm">
        <thead>
          <tr>
            <th className="border border-gray-300 p-2">{getCustomsAgentManagementTranslation('agentName', isSpanish)}</th>
            <th className="border border-gray-300 p-2">{getCustomsAgentManagementTranslation('agentTaxId', isSpanish)}</th>
            <th className="border border-gray-300 p-2">{getCustomsAgentManagementTranslation('agentEori', isSpanish)}</th>
            <th className="border border-gray-300 p-2">{getCustomsAgentManagementTranslation('agentAddress', isSpanish)}</th>
            <th className="border border-gray-300 p-2">{getCustomsAgentManagementTranslation('agentCity', isSpanish)}</th>
            <th className="border border-gray-300 p-2">{getCustomsAgentManagementTranslation('agentCountry', isSpanish)}</th>
            <th className="border border-gray-300 p-2">{getCustomsAgentManagementTranslation('actions', isSpanish)}</th>
          </tr>
        </thead>
        <tbody>
          {agents && agents.length > 0 ? (
            agents.map((agent) => (
              agent && (
                <tr key={agent.id}>
                  <td className="border border-gray-300 p-2">{agent.nombre}</td>
                  <td className="border border-gray-300 p-2">{agent.nif}</td>
                  <td className="border border-gray-300 p-2">{agent.eori}</td>
                  <td className="border border-gray-300 p-2">{agent.direccion}</td>
                  <td className="border border-gray-300 p-2">{agent.localidad}</td>
                  <td className="border border-gray-300 p-2">{agent.pais}</td>
                  <td className="border border-gray-300 p-2 w-fit">
                    <div className='relative text-sm'>
                      <button 
                        className={`flex gap-2 justify-between items-center border-containera bg-gray-100 hover:bg-gray-200 rounded-full p-2 px-4 w-full`} 
                        onClick={() => {
                          const dropdownKey = `${agent.id}`;
                          setOpenDropdownId(openDropdownId === dropdownKey ? null : dropdownKey);
                        }}
                        disabled={isLoading}
                      >
                        <p className='truncate'>{getCustomsAgentManagementTranslation('selectAction', isSpanish)}</p>
                        <ChevronDown className={`w-4 h-4 ${openDropdownId === `${agent.id}` && "rotate-180"}`} />
                      </button>
                      {openDropdownId === `${agent.id}` && (
                        <div className='min-w-52 right-0 flex flex-col absolute z-10 bg-white mt-1 w-full border-containera shadow-md rounded-xl max-h-80 overflow-auto p-2'>
                          <p className='opacity-75 px-2 py-1 text-xs'>{getCustomsAgentManagementTranslation('selectAction', isSpanish) || (isSpanish ? 'Seleccionar Acción' : 'Select Action')}</p>
                          <span 
                            className="px-2 py-1 hover:bg-gray-100 cursor-pointer rounded-full"
                            onClick={() => {
                              handleEdit(agent);
                              setOpenDropdownId(null);
                            }}
                          >
                            {getCustomsAgentManagementTranslation('edit', isSpanish)}
                          </span>
                          <span 
                            className='px-2 py-1 hover:bg-gray-100 cursor-pointer rounded-full' 
                            onClick={() => {
                              openDeleteModal(agent);
                              setOpenDropdownId(null);
                            }}
                          >
                            {getCustomsAgentManagementTranslation('delete', isSpanish)}
                          </span>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              )
            ))
          ) : (
            <tr>
              <td colSpan="7" className="border border-gray-300 p-2 text-center">
                {getCustomsAgentManagementTranslation('noAgentsFound', isSpanish)}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    )
}